import { render, staticRenderFns } from "./AssignmentsGrossProfits.vue?vue&type=template&id=6f3454c0"
import script from "./AssignmentsGrossProfits.vue?vue&type=script&lang=js"
export * from "./AssignmentsGrossProfits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports